import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'Generelt',
    [Tab.SignedLive]: 'Underskrevet / Live',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Provision',
  },
};
